<template>
	<div>
		<loading :active.sync="isLoading"></loading>

		<h6 class="element-header capitalize">
			{{ marketNameLn }}

		</h6>

		<table-component

				v-if="status == 200"
				table-class="table table-padded"
				filter-input-class="form-control col-4 float-right rounded bright"
				:data="data"
				sort-by="id"
				sort-order="desc"
		>

			<table-column :label="t.bet" show="outcome" >
			</table-column>

			<table-column :label="t.played_bets" show="played" cell-class="w150">
			</table-column>

			<table-column :label="t.total_odd" cell-class="w150">
				<template scope="row">
					<span>{{ row.totalOdd }}</span>
				</template>
			</table-column>

			<table-column label="%">
				<template scope="row">
					<span>{{ row.played | percentage(totalPlayed) }}%</span>
				</template>
			</table-column>

		</table-component>
	</div>
</template>

<script>
    import formatter from '@/mixins/formatter'
    import { TableComponent, TableColumn } from 'vue-table-component'

    export default {
        name: 'playedBets',
        components: { 'table-component': TableComponent, 'table-column': TableColumn},
        mixins: [formatter],
	    props: {
            market: null,
		    period: null,
            marketName: null
	    },
        data () {
            return {
                isLoading: false,
                t: this.$root.t,
                data: '',
                status: 0,
                w: window.innerWidth,
                totalPlayed: 0,
                selectedPeriod: 'today',
                accountingPeriods: [
                    { label: 'Today', value: 'today' },
                    { label: 'Yesterday', value: 'yesterday' },
                    { label: 'This Week', value: 'this_week' },
                    { label: 'This Month', value: 'this_month' },
                    { label: 'Q1', value: 'q1' },
                    { label: 'Q2', value: 'q2' },
                    { label: 'Q3', value: 'q3' },
                    { label: 'Q4', value: 'q4' },
                    { label: 'Financial First Half', value: 'first_financial_half' },
                    { label: 'Financial Second Half', value: 'second_financial_half' },
                ],
                sports: null,
                sport: 1,
	            marketData: null
            }
        },
        watch: {
            'selectedPeriod' () {
                this.fetchReport()
            },
            market: {
                // the callback will be called immediately after the start of the observation
                immediate: true,
                deep: true,
                handler (val, oldVal) {
                    // do your stuff
	                this.fetchReport()
                }
            }
        },
        mounted () {
            this.fetchReport()
        },
        methods: {
            fetchReport () {
                if (this.market > 0) {
                    this.isLoading = true;
                    this.$http.get(api+'api/v1/analytics/bet/selections', {params: { market: this.market, period: this.period}}).then(response => {

                        // get body data
                        this.data = response.body.result;
                    this.marketData = response.body.market;
                    this.marketNameLn = response.body.marketNameLn;
                    this.totalPlayed = response.body.totalPlayed;
                    this.isLoading = false;
                    this.status = response.status;

                }, response => {
                        this.isLoading = false;
                        this.status = response.status;
                    })
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/playedBets.vue